module.exports = __webpack_public_path__ + "static/media/p1.220f7283.png";